export enum CategoriesEnum {
  WeeklyLetter = 1,
  MonthlyLetter,
  Activities,
  WorkEnvironment,
  BossLetter,
  EmployeesDocument = 7,
  Widely,
}
